export default {
  INIT_EXPAND_COLLAPSE: 'ExpandCollapseContstants.INIT_EXPAND_COLLAPSE',
  TOGGLE_EXPAND_COLLAPSE: 'ExpandCollapseContstants.TOGGLE_EXPAND_COLLAPSE',
};
